import logo from "./logo.svg";
import "./App.css";
import SortingVisualizer from "../src/SortingVisualizer/SortingVisualizer";
function App() {
  return (
    <div className="App">
      <SortingVisualizer></SortingVisualizer>
    </div>
  );
}

export default App;
